import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=669bffd4&scoped=true"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"
import style0 from "./CatalogView.vue?vue&type=style&index=0&id=669bffd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669bffd4",
  null
  
)

export default component.exports